import React from 'react';

/**
 * Render the best available body for an email.
 * Priority: body_html > message > body_text > raw dump.
 * <img> tags are stripped so email HTML never loads remote trackers.
 */
export default function EmailBody({ email }) {
  const html = email.body_html || email.message;
  if (html) {
    const cleanHtml = String(html).replace(/<img[^>]*>/gi, '');
    return (
      <div style={{ lineHeight: 1.6, overflowWrap: 'anywhere' }} dangerouslySetInnerHTML={{ __html: cleanHtml }} />
    );
  }

  const plain = email.body_text || email.body;
  if (plain) {
    return (
      <pre style={{
        whiteSpace: 'pre-wrap', wordBreak: 'break-word',
        lineHeight: 1.6, fontFamily: 'inherit', margin: 0,
      }}>
        {plain}
      </pre>
    );
  }

  return (
    <pre className="mono muted" style={{
      whiteSpace: 'pre-wrap', wordBreak: 'break-word', margin: 0,
      background: 'var(--color-bg)', padding: '12px', borderRadius: 'var(--radius)',
    }}>
      {JSON.stringify(email, null, 2)}
    </pre>
  );
}
